var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['acceptance-status-badge', _vm.status]},[_vm._v(" "+_vm._s(_vm.status)+" "),_c(_setup.Icon,{attrs:{"name":_vm.status+'_icon'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }